import Pullquote from './pullquote'
import PullquoteQuery from './pullquote.query'

export { PullquoteQuery }

export default Pullquote
